<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth" :inline="true">
        <el-form-item label="名字" prop="name">
          <el-input v-model="searchForm.searchContent" placeholder="请输入直播名字" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column prop="id" label="id" width="240"></el-table-column>
        <el-table-column prop="imgUrl" label="封面">
          <template slot-scope="scope">
            <img
              width="120px"
              height="80px"
              :src="scope.row.imgUrl"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名字" width="300"></el-table-column>
        <el-table-column prop="aliveStartAt" label="开始时间"></el-table-column>
        <el-table-column prop="aliveStopAt" label="结束时间"></el-table-column>
        <el-table-column prop="aliveType" label="直播类型">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveType === 10">横屏直播</span>
            <span v-if="scope.row.aliveType === 11">竖屏直播</span>
            <span v-if="scope.row.aliveType === 12">语音直播</span>
            <span v-if="scope.row.aliveType === 13">录播直播</span>
          </template>
        </el-table-column>
        <el-table-column prop="alive_state" label="直播状态">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveState === 0">未开始</span>
            <span v-if="scope.row.aliveState === 1">直播中</span>
            <span v-if="scope.row.aliveState === 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="replayNumber" label="单节点回放/层级回访">
          <template slot-scope="scope">
            <span class="mainColor" @click="goUploadPage(scope.row)">{{ scope.row.videoCount || 0 }} / {{ scope.row.subjectVideoCount || 0 }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "xiaoETongLiveInfo",
  data() {
    return {
      loading: false,
      dialogWidth:
        document.body.clientWidth <= 1366
          ? "55%"
          : document.body.clientWidth > 1366 &&
          document.body.clientWidth <= 1920
          ? "45%"
          : "40%",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        searchContent: "",
      },
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.page = this.page.pageNumber;
      this.api.xiaoETongLiveInfo.pageList(this.searchForm).then(result => {
        this.loading = false;
        this.page.rows = result.data.data.list;
        this.page.total = result.data.data.total;
      }).catch(error => {
        console.log(error);
      });
    },
    goUploadPage(row) {
      this.$router.push({
        path: "/checkVideo",
        query: { id: row.newId, name: '录播' },
      });
    },
  },
  watch: {

  },
  mounted() {
    this.pageList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiaoETongLiveInfo/index.vue